import { type ApiError, useApi } from '@omnipresentgroup/api';
import type {
  GetXeroAccountCodeMappingsResponseAPI,
  XeroAccountCodeMappingItem,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import {
  XERO_INTEGRATION_API_BASE,
  XERO_INTEGRATION_API_PATH,
  XERO_INTEGRATION_XERO_ACCOUNT_CODE_MAPPINGS_PATH,
} from '../constants';
import { transformXeroAccountCodeMappingsFromAPI } from '../mappers';

export const getXeroAccountCodeMappingsKey = (clientId: string) => [
  XERO_INTEGRATION_API_PATH,
  clientId,
  XERO_INTEGRATION_XERO_ACCOUNT_CODE_MAPPINGS_PATH,
];

export const useXeroAccountCodeMappings = ({
  clientId,
}: {
  clientId: string;
}) => {
  const { GET } = useApi();
  const query = useQuery<
    GetXeroAccountCodeMappingsResponseAPI,
    ApiError,
    XeroAccountCodeMappingItem[]
  >({
    queryKey: getXeroAccountCodeMappingsKey(clientId),
    queryFn: () =>
      GET<GetXeroAccountCodeMappingsResponseAPI>(
        `${XERO_INTEGRATION_API_BASE}/${XERO_INTEGRATION_API_PATH}/${clientId}/${XERO_INTEGRATION_XERO_ACCOUNT_CODE_MAPPINGS_PATH}`,
      ),
    select: transformXeroAccountCodeMappingsFromAPI,
    enabled: !!clientId,
  });

  return query;
};
